import { Controller } from "@hotwired/stimulus"

// Manages the quality indicator for the AI prompt textarea.
// Gray (0 chars) → Amber (1–49 chars) → Green (50+ chars)
export default class extends Controller {
  static targets = ["textarea", "indicator", "label", "hints"]

  update() {
    const len = this.textareaTarget.value.length

    if (len === 0) {
      this.setIndicator('bg-gray-300', 'Start typing to add your vision...')
      if (this.hasHintsTarget) this.hintsTarget.classList.remove('hidden')
    } else if (len < 50) {
      this.setIndicator('bg-amber-400', `${len} chars — a bit more detail helps the AI`)
      if (this.hasHintsTarget) this.hintsTarget.classList.add('hidden')
    } else {
      this.setIndicator('bg-green-500', `${len} chars — great detail!`)
      if (this.hasHintsTarget) this.hintsTarget.classList.add('hidden')
    }
  }

  setIndicator(colorClass, text) {
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.className = `w-2.5 h-2.5 rounded-full transition-colors duration-300 ${colorClass}`
    }
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = text
    }
  }
}
